
// VendasPage.js

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import ExibirVenda from '../../components/ExibirVenda.js';
import CadastrarVenda from '../../components/CadastrarVenda.js';
import EditarVenda from '../../components/EditarVenda.js';
import ListarVendas from '../../components/ListarVendas.js';
import BotoesdeNavegacao from '../../components/BotoesdeNavegacao.js';
import BotoesDeAcao from '../../components/BotoesDeAcao.js';
import { useNavigate } from 'react-router-dom';
//import Axios from 'axios';
import api from '../../config/axiosConfig'; 
import '../../App.css';

function VendasPage() {
  const { theme } = useTheme();
  const [vendas, setVendas] = useState([]);
  const [selectedVenda, setSelectedVenda] = useState("");
  const [showCadastroVenda, setShowCadastroVenda] = useState(false);
  const [showEditaVenda, setShowEditaVenda] = useState(false);
  const [showExibeVenda, setShowExibeVenda] = useState(false);
  const [showListaVendas, setShowListaVendas] = useState(false); // Estado para controlar a exibição do componente Listarvendas
  // eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [totalPages, setTotalPages] = useState(1); // Inicialmente 1 página
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState({ codvenda: '', nomecli: '', cnpjcli: '' });
  const navigate = useNavigate(); // Definindo o useNavigate
  
// Função para carregar as vendas
const loadVendas = async (pageNumber = 1) => {
  console.log('Carregando vendas...');
  try {
    // Primeiro, carregue a quantidade total de vendas
    const countResponse = await api.get(`/vendas/listarvendas`, {
  });

    const totalVendas = countResponse.data.totalElements;
    const pageSize = 10; // Tamanho fixo da página
    const totalPages = Math.ceil(totalVendas / pageSize);
    
    // Solicite a última página de vendas
    const lastPage = totalPages > 0 ? totalPages - 1 : 0;
    const response = await api.get(`/vendas/listarvendas/paginados?page=${lastPage}&size=${pageSize}`);
    
    setVendas(response.data.content);
    
    // Se houver vendas, selecione a última venda
    if (response.data.content.length > 0) {
      const lastVenda = response.data.content[response.data.content.length - 1];
      setSelectedVenda(lastVenda);
      setShowExibeVenda(true);
    }
    
    setTotalPages(totalPages);
  } catch (error) {
    console.error('Erro ao carregar vendas:', error);
  }
  };
  
  
// Função para exibir a venda selecionado
const handleCodvendaClick = async (vendaCodvenda) => {
  try {
    // Fechar o componente ListarVendas
    handleSairListarClick();

    // Buscar a venda pelo código
    const response = await api.get(`/vendas/buscarvenda?codvenda=${vendaCodvenda}`);

    if (response.data) {
      const venda = response.data; // A API está retornando um objeto único de venda
      setSelectedVenda(venda); // Define a venda selecionada
      setShowExibeVenda(true); // Exibe o componente de exibição de venda
    } else {
      window.alert('Venda não encontrada.');
    }
  } catch (error) {
    console.error('Erro ao buscar venda:', error);
    window.alert('Erro ao buscar venda. Verifique o console para mais detalhes.');
  }
};
  
// Funções de navegação
// Função para buscar a primeira venda
const fetchPrimeiraVenda = async () => {
  try {
    const response = await api.get('/vendas/primeira');
    

    if (response.data && response.data.codvenda) {
      console.log('Primeira venda encontrada-02:', response.data);
      setSelectedVenda(response.data);
      setShowExibeVenda(true);
      } else {
        console.log('Nenhuma Venda Cadastrada.');
        setSelectedVenda(response.data);
        setShowExibeVenda(true);
        window.alert('Nenhuma Venda Cadastrada.');
      }
    } catch (error) {
      console.error('Erro ao buscar a Primeira Venda:', error);
      setSelectedVenda("");
      setShowExibeVenda(true);
      window.alert('Nenhuma Venda Cadastrada.');
    }
  };
  
// Função para buscar a Venda Anterior
const fetchVendaAnterior = async () => {
  if (selectedVenda && selectedVenda.id) {
    console.log('Buscando venda anterior para o ID:', selectedVenda.id);
    try {
      const response = await api.get(`/vendas/anterior/${selectedVenda.id}`);

      if (response.data) {
        //console.log('venda anterior encontrada:', response.data);
        setSelectedVenda(response.data);
        setShowExibeVenda(true);
      } else {
        console.warn('Nenhuma venda anterior encontrada.');
      }
    } catch (error) {
      console.error('Erro ao buscar o venda anterior:', error);
    }
  } else {
    console.error('Nenhum venda selecionado ou venda sem ID');
  }
};
  
// Função para buscar a venda posterior
const fetchVendaPosterior = async () => {
  if (selectedVenda && selectedVenda.id) {
      console.log('Buscando venda posterior para o ID:', selectedVenda.id); // Log do ID do venda selecionado
    try {
      const response = await api.get(`/vendas/proxima/${selectedVenda.id}`);

      if (response.data) {
        //console.log('venda posterior encontrada:', response.data); // Log do venda posterior encontrado
        setSelectedVenda(response.data);
        setShowExibeVenda(true);
        } else {
          console.warn('Nenhum venda posterior encontrada.');
        }
      } catch (error) {
        console.error('Erro ao buscar a venda posterior:', error);
      }
    } else {
      console.error('Nenhuma venda selecionado ou venda sem ID');
    }
  };

// Função para buscar a última venda
const fetchUltimaVenda = async () => {
  try {
    const response = await api.get('/vendas/ultima');

    if (response.data) {
      //console.log('Última venda encontrada:', response.data);
      setSelectedVenda(response.data);
      setShowExibeVenda(true);
    }
  } catch (error) {
    console.error('Erro ao buscar a última venda:', error);
  }
};

  
  // Efeito para carregar a última venda quando o componente for montado
    useEffect(() => {
    fetchUltimaVenda();
  }, [currentPage]);


  // Função para Buscar Venda por Código da Venda
  const fetchVendaPorCodvenda = async (codvenda) => {
    console.log('Buscando venda por Código da Venda:', codvenda);
    try {
      const response = await api.get(`/vendas/buscarvenda?codvenda=${codvenda}`);

    if (response.data) {
        console.log('Venda encontrada por Código:', codvenda);
        setSelectedVenda(response.data);  // Acessa diretamente o objeto retornado
        setShowExibeVenda(true);
      } else {
        console.warn('Venda não encontrada por Código: ', codvenda);
        window.alert('Venda não encontrada por Código: ', codvenda);
        fetchUltimaVenda();
      }
    } catch (error) {
      console.error('Erro ao buscar venda por Código da Venda:', error);
      window.alert('Venda Não Encontrada por Código da Venda: ', codvenda);
      fetchUltimaVenda();
    }
  };


  // Função para Buscar Venda por Nome do Cliente
  const fetchVendaPorNomecli = async (nomecli) => {
    console.log('Buscando venda mais recente por Nome do Cliente:', nomecli);
    try {
        const response = await api.get(`/vendas/buscarvenda?nomecli=${nomecli}`);

        if (response.data) {
            console.log('Venda encontrada por Nome do Cliente:', nomecli);
            setSelectedVenda(response.data);
            setShowExibeVenda(true);
        } else {
            console.warn('Venda não encontrada por Nome do Cliente:', nomecli);
            window.alert('Venda não encontrada por Nome do Cliente:', nomecli);
            fetchUltimaVenda();
        }
    } catch (error) {
        console.error('Erro ao buscar venda por Nome do Cliente:', error);
        window.alert('Erro ao buscar venda por Nome do Cliente');
        fetchUltimaVenda();
    }
};

  // Função para buscar venda mais recente por CNPJ do Cliente
  const fetchVendaPorCnpjcli = async (cnpjcli) => {
    console.log('Buscando venda por CNPJ do Cliente:', cnpjcli);
    try {
        const response = await api.get(`/vendas/buscarvenda?cnpjcli=${cnpjcli}`);

        if (response.data) {
            console.log('Venda encontrada por CNPJ do Cliente:', cnpjcli);
            setSelectedVenda(response.data);
            setShowExibeVenda(true);
        } else {
            console.warn('Venda não encontrada por CNPJ do Cliente:', cnpjcli);
            window.alert('Venda não encontrada por CNPJ do Cliente:', cnpjcli);
            fetchUltimaVenda();
        }
    } catch (error) {
        console.error('Erro ao buscar venda por CNPJ do Cliente:', error);
        window.alert('Erro ao buscar venda por CNPJ do Cliente');
        fetchUltimaVenda();
    }
};

  // Função para listar vendas cadastradas
  const handleListarClick = () => {
    setShowListaVendas(true); // Ao clicar no botão Listar, mostrar o componente Listarvendas
    setShowExibeVenda(false); // Esconder o componente ExibirVenda
  };

  // Função para sair do Listarvendas
  const handleSairListarClick = () => {
    setShowListaVendas(false); // Ao clicar no botão Sair do Listarvendas, esconder o componente Listarvendas
    setShowExibeVenda(true); // Mostrar novamente o componente ExibExibirVendairvenda
  };

  // Função para cadastrar Nova venda
  const handleNovoClick = () => {
    setSelectedVenda("");
    setShowCadastroVenda(true);
    setShowEditaVenda(false);
    setShowExibeVenda(false);
  };

  // Função para Salvar Cadastro Nova venda
  const handleSalvarNovaVenda = (venda) => {
    setVendas([...vendas, venda]);
    setSelectedVenda(venda);
    setShowCadastroVenda(false);
    setShowExibeVenda(false);
    setShowEditaVenda(true);
    ///window.alert('Venda Salva com Sucesso');
  };

  // Função para cancelar o cadastro da venda
  const handleCancelarNovaVenda = () => {
    setShowCadastroVenda(false);
    fetchUltimaVenda(); // Carrega a última venda da lista
    setShowExibeVenda(true);
  };

  // Função para editar Venda Selecionado
  const handleEditClick = () => {
    setShowEditaVenda(true);
    setShowCadastroVenda(false);
    setShowExibeVenda(false);
  };

  // Função para Salvar Venda Editada
  const handleSalvaEditada = (venda) => {
    setVendas([...vendas, venda]);
    setSelectedVenda(venda);
    setShowExibeVenda(true);
    setShowEditaVenda(false);
    //window.alert('Venda Editada com Sucesso');
  };

  // Função para cancelar a edição de venda
  const handleCancelaEditada = () => {
    setShowCadastroVenda(false);
    setShowEditaVenda(false);
    setShowExibeVenda(true);
  };

  // Função para fechar a página de exibição e ir para a página inicial
  const handleCancelaExibe = () => {
    setShowCadastroVenda(false);
    setShowEditaVenda(false);
    setShowExibeVenda(false);
    setVendas(""); // Reseta o estado da venda
    navigate('/home'); // Redireciona para a página inicial
  };

const handleDeleteClick = async () => {
  if (selectedVenda) {
    const confirmation = window.confirm(`Tem certeza que deseja excluir a venda ${selectedVenda.codvenda}?`);
    if (confirmation) {
      try {
        // Verifica se a venda tem itens associados
        const itensResponse = await api.get(`/vendas/venda/${selectedVenda.codvenda}/itens`);

        const itensVenda = itensResponse.data;

        if (itensVenda.length > 0) {
          // Se houver itens, mostra um alerta informando que os itens precisam ser excluídos primeiro
          window.alert('Para Excluir a Venda, antes é necessário Excluir os Itens desta Venda.');
        } else {
          // Se não houver itens, procede com a exclusão da venda
          await api.delete(`/vendas/excluirvenda/${selectedVenda.codvenda}`);

          window.alert(`Venda: ${selectedVenda.codvenda} Excluída com Sucesso.`);

          // Carregar vendas novamente
          loadVendas(currentPage);
          // Buscar e exibir a última venda
          fetchUltimaVenda();
        }
      } catch (error) {
        console.error('Erro ao excluir a venda:', error);
      }
    }
  } else {
    console.error('Nenhuma venda selecionada para excluir');
  }
};

// Se os campos de busca estiverem sendo exibidos, limpa os campos de busca
  const handleSearchClick = () => {
    if (!isSearchVisible) {
    setSearchQuery({ codvenda: '', nomecli: '', cnpjcli: '' });
  }
    setIsSearchVisible(!isSearchVisible);
  };
  

// A função handleSearchChange faz a busca apenas quando a tecla Enter é pressionada
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchQuery({ ...searchQuery, [name]: value });
  };


  // Se a tecla pressionada for Enter, executar a busca
  const handleSearchByCodigo = (e) => {
    if (e.key === 'Enter') {
      fetchVendaPorCodvenda(searchQuery.codigo);
    }
  };

  const handleSearchByNome = (e) => {
    if (e.key === 'Enter') {
      fetchVendaPorNomecli(searchQuery.nome);
    }
  };

  const handleSearchByCNPJ = (e) => {
    if (e.key === 'Enter') {
      fetchVendaPorCnpjcli(searchQuery.cnpj);
    }
  };


  return (
    <div
      style={{
        backgroundColor: theme.background,
        color: theme.color,
        minHeight: 'calc(100vh - 20px)',
        width: '100%',
        paddingTop: '10px',
        textAlign: 'center',
      }}
    >
      <Header selectedEmpresa={localStorage.getItem('selectedEmpresa')} />


      {!showCadastroVenda && selectedVenda && !showEditaVenda && showExibeVenda && (
      <>
      <BotoesdeNavegacao
      fetchPrimeiro={fetchPrimeiraVenda}
      fetchAnterior={fetchVendaAnterior}
      fetchProximo={fetchVendaPosterior}
      fetchUltimo={fetchUltimaVenda}
      />
      <BotoesDeAcao
      handleNovoClick={handleNovoClick}
      handleEditClick={handleEditClick}
      handleDeleteClick={handleDeleteClick}
      handleSearchClick={handleSearchClick}
      handleListarClick={handleListarClick} // Verifique se handleListarClick está passada corretamente
      isSearchVisible={isSearchVisible}
      handleSearchChange={handleSearchChange}
      handleSearchByCodigo={handleSearchByCodigo}
      handleSearchByNome={handleSearchByNome}
      handleSearchByCNPJ={handleSearchByCNPJ}
      searchQuery={searchQuery}
      />
      <ExibirVenda venda={selectedVenda || {}}
        handleCancelaExibe={handleCancelaExibe}
      />
      </>
      )}

      
      {showListaVendas && (
        <ListarVendas
          onCodvendaClick={handleCodvendaClick} // Passa a função para quando o código da venda é clicado
          handleSairListarClick={handleSairListarClick} // Passa a função para fechar a listagem
        />
      )}


      {showCadastroVenda && (
        <CadastrarVenda
          handleSaveClick={handleSalvarNovaVenda}
          //handleCloseClick={handleFecharNovaVenda}
          handleCancelaClick={handleCancelarNovaVenda}
          venda={selectedVenda}
        />
      )}

      
      {showEditaVenda && (
      <EditarVenda
      venda={selectedVenda}
      handleEditClick={handleSalvaEditada}
      handleCancelaEdit={handleCancelaEditada}
      />
      )}
      
  </div>
  );
}

export default VendasPage;
